<br>
<!--div *ngIf="!showLabelsAsHtml" class="form-row buttontup btntop col-sm-12" style="margin-top: 10px;">
  <table>
    <tr>
      <td>
        <button class="btn border" (click)="search()">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="clear()">Rensa</button>
      </td>

    </tr>
  </table>
  <p class="reportlabel">Rapport: Institutioner</p>
</div-->

<div *ngIf="!showLabelsAsHtml" class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" (click)="search()">Sök</button>
        <button class="btn border" (click)="clear()">Rensa</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Institutioner</p>

    </div>
  </div>
</div>

<div *ngIf="!showLabelsAsHtml" class="col-xl-11 ms-4 me-4">
  <div class="row">
    <div class="col-md-3">
      <form [formGroup]="institutionform" (keydown.enter)="search()">


        <mat-expansion-panel class="accordionmargin" [expanded]=true>
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Institution
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="form-group">
            <label for="institutionTypeId">
              Institutionstyp
            </label>
            <select class="form-control form-control-sm" id="institutionTypeId"  formControlName="institutionTypeId">
              <option></option>
              <option *ngFor="let i of institutiontypes" [ngValue]="i.id">{{i.prefix}} - {{i.name}}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="institutionNumber">
              Nummer
            </label>
            <input type="text" class="form-control form-control-sm cap" id="institutionNumber" formControlName="institutionNumber">
          </div>

          <div class="form-group">
            <label for="institutionNumber">
              Institutionsnamn
            </label>
            <input type="text" class="form-control form-control-sm cap" id="institutionName" formControlName="institutionName">
          </div>

          <div class="form-group">
            <label for="visitingCity">
              Ort
            </label>
            <input type="text" class="form-control form-control-sm cap" id="visitingCity" formControlName="visitingCity">
          </div>

          <div class="form-group">
            <label for="seat">
              Säte
            </label>
            <input type="text" class="form-control form-control-sm cap" id="seat" formControlName="seat">
          </div>

          <div class="form-group">

            <label for="districtId">
              Distrikt
            </label>
            <select class="form-control form-control-sm" id="districtId" formControlName="districtId">
              <option></option>
              <option *ngFor="let d of districtlist" [ngValue]="d.id">{{d.shortName}} - {{d.name}}</option>
            </select>
          </div>

          <div class="form-group">

            <label>
              Instituerad mellan
            </label>


            <div class="form-check-inline">
              <app-calendarnotrequired [form]="institutionform" formName="startDateFrom"></app-calendarnotrequired>&nbsp;
              <app-calendarnotrequired [form]="institutionform" formName="startDateTo"></app-calendarnotrequired>

              <!--input type="text" class="col-sm-6 col-lg-6 form-control form-control-sm cap" id="startDateFrom" formControlName="startDateFrom">&nbsp;
              <input type="text" class="col-sm-6 col-lg-6 form-control form-control-sm cap" id="startDateTo" formControlName="startDateTo"-->
            </div>
          </div>

          <div class="form-group">

            <label>
              Avvecklad mellan
            </label>


            <div class="form-check-inline">
              <app-calendarnotrequired [form]="institutionform" formName="endDateFrom"></app-calendarnotrequired>&nbsp;
              <app-calendarnotrequired [form]="institutionform" formName="endDateTo"></app-calendarnotrequired>
              <!--input type="text" class="col-sm-6 col-lg-6 form-control form-control-sm cap" id="endDateFrom" formControlName="endDateFrom">&nbsp;
              <input type="text" class="col-sm-6 col-lg-6 form-control form-control-sm cap" id="endDateTo" formControlName="endDateTo"-->
            </div>
          </div>

          <div class="form-group">
            <label for="meetingInterval">
              Installation
            </label>
            <select class="form-control form-control-sm" id="meetingInterval" formControlName="meetingInterval">
              <option></option>
              <option>Jämna år</option>
              <option>Udda år</option>
              <option>Båda</option>
            </select>
          </div>

        </mat-expansion-panel>

      </form>

    </div>

    <div *ngIf="!selectyears && !showLabelsAsHtml" class="col-md-9">
      <table *ngIf="institutionresult.length > 0" class="table" style="width: 400px;">
        <tr>
          <!--td>
            Antal träffar: {{institutionresult.length}}
          </td-->
          <td *ngIf="ifSomekindofAdmin">
            <i class="fa fa-file-excel-o" aria-hidden="true" style="color: green;font-size:24px;cursor: pointer;" (click)="exportToCSV()"
              title="Skapa Excelfil"></i>

          </td>

          <!--td *ngIf="selectedinstitutions.length > 0 && viewtinymatrix" style="text-align:center;">
            <i class="fa fa-address-card-o" aria-hidden="true" title="Skapa lilla matrikeln för valda institutioner" (click)="createLillaMatrikeln()"
               style="color: #920000;font-size:24px;cursor: pointer;"></i>
              <i *ngIf="showlillamatrikeln" class="fa fa-floppy-o" aria-hidden="true" aria-hidden="true" title="Skapa PDF" (click)="captureScreen()"
              style="color: #920000;font-size:24px;cursor: pointer;margin-left:20px;"></i>
              <i *ngIf="showlillamatrikeln" class="fa fa-times" aria-hidden="true" title="Stäng Lilla Matrikeln" (click)="closeLittleMatrix();selectedinstitutions=[];" style="color: black;font-size:24px;cursor: pointer;margin-left:20px;"></i>

          </td-->



          <td *ngIf="selectedinstitutions.length > 0 && viewmemfee && (isClerk || isSysAdmin)" style="text-align:center;">
            <i class="fa fa-money" aria-hidden="true" title="Skapa lista över valda institutioners medlemsavgifter" (click)="chooseYear()"
              style="color:green;font-size:24px;cursor: pointer;"></i>
          </td>

        </tr>
      </table>
      <div *ngIf="institutionresult.length > 0">

      
              <!--p-menubar [model]="items">
                <div class="d-flex justify-content-end mt-2 mr-3">
                  Resultat: {{institutionresult?.length}}
              </div>
              </p-menubar-->

              <p-menubar [model]="items">
                <div class="d-flex justify-content-end align-items-center me-2">
                 <span *ngIf="selectedinstitutions.length>0" class="me-2 cursor-pointer btn-link" title="Etikettformat A4 ark Avery 3475 eller Herma 4453">Etikettinfo</span>
       
                  <div>Resultat: {{institutionresult?.length}}</div>
                  <span class="ms-2">Välj alla:
                    <mat-checkbox #checkAll (change)="checkuncheckAll(checkAll);"></mat-checkbox>
                  </span>
                </div>
              </p-menubar>

              <table *ngIf="!showlillamatrikeln" matSort (matSortChange)="sortData($event)" class="table col-md-12 border" matSortDisableClear=true style="min-width: 1000px;">
          <thead role="rowgroup">
            <tr>
              <th mat-sort-header="districtShortName">Distr Kortnamn</th>
              <th mat-sort-header="shortName">Kortnamn</th>
              <th mat-sort-header="name">Namn</th>
              <th mat-sort-header="seat">Säte</th>
              <th mat-sort-header="startDate">Startdatum</th>
              <th mat-sort-header="endDate">Slutdatum</th>
              <th mat-sort-header="memberCount">Antal</th>
              <th style="z-index:10000;">Välj</th>

            </tr>
          </thead>

          <tr *ngFor="let inst of institutionresult;" title="Titta på institutionsdetaljer">
            <td>{{inst.districtShortName}}</td>
            <td>{{inst.shortName}}</td>
            <td style="text-decoration: underline;color:royalblue;cursor: pointer;" (click)="viewInstitution(inst.id)">{{inst.name}}</td>
              <!--td><a [routerLink]="['/institutions']" [queryParams]="{id: inst.id, viewmode: true}" queryParamsHandling="merge" title="Titta på institutionsdetaljer">{{inst.name}}</a></td-->
            <td>{{inst.seat}}</td>
            <td>{{inst.startDate | date: 'yyyy-MM-dd'}}</td>
            <td *ngIf="(inst.endDate | date: 'yyyy-MM-dd') !== '9999-12-31'">{{inst.endDate | date: 'yyyy-MM-dd'}}</td>
            <td *ngIf="(inst.endDate | date: 'yyyy-MM-dd') === '9999-12-31'"></td>
            <td>{{inst.memberCount}}</td>
            <td style="text-align: center;vertical-align: middle;width:5%;">
              <mat-checkbox #inputEl (change)="add(inst, inputEl);" [checked]="inst.checked"></mat-checkbox>
            </td>
          </tr>
        </table>
      </div>



<div *ngIf="showlillamatrikeln">  </div>
<div id="contentToConvert" class="pdfcontainer">

    <div *ngIf="showlillamatrikeln" style="width:1000px;border:1px solid lightgrey;">



        <table style="width:1000px;">
            <div *ngFor="let m of matrikellist" style="width:1000px;">
          <tr style="font-weight:bold;">
            <td class="tdheader">{{m.typeName}} {{m.shortName}} {{m.name}}</td>
            <td class="tdheader">{{m.parent[0].shortName}} {{m.parent[0].name}}</td>
          </tr>
          <tr>
            <td class="tdheader">Instituerad: {{m.instituerad}}</td>
            <td class="tdheader">Logetelefon: {{m.phone}}</td>
          </tr>
          <tr>
            <td class="tdheader">Installation: {{m.installationInterval}}</td>
            <td class="tdheader">E-post: {{m.email}}</td>
          </tr>
          <tr>
            <td class="tdheader">Möten: {{m.meetingInterval}}</td>
            <td class="tdheader"></td>
          </tr>
          <tr>
            <td class="tdheader">Postgiro: {{m.bankAccount1}}</td>
            <td class="tdheader">Bankgiro: {{m.bankAccount2}}</td>
          </tr>
          <tr>
            <td class="tdheader">Besöksadress:</td>
            <td class="tdheader">Postadress:</td>
          </tr>
          <tr>
            <td class="tdheader">{{m.visitingAddress?.street}}</td>
            <td class="tdheader">{{m.paymentAddress?.street}}</td>
          </tr>
          <tr>
            <td class="tdheader">{{m.visitingAddress?.city}}</td>
            <td class="tdheader">{{m.paymentAddress?.zipCode}} {{m.paymentAddress?.city}}</td>
          </tr>

          <tr>
            <td class="tdheader"></td>
            <td class="tdheader">{{m.paymentAddress?.country}}</td>
          </tr>

          <br><br>

          <div style="border-bottom:1px solid lightgrey;"></div>

          <div *ngFor="let o of m.offices" style="width:1000px;border-bottom:1px solid lightgrey;">

            <tr>
            <td class="tdoffice">{{o.abbreviation}}</td><td class="tdoffice">{{o.givenName}} {{o.familyName}}, {{o.title}}</td><td class="tdoffice">Tel bostad: {{o.phone}}</td>
           </tr>
          <tr>
            <td class="tdoffice"></td><td class="tdoffice">{{o.street}}</td><td class="tdoffice">Tel arbete: {{o.phoneWork}}</td>
          </tr>

          <tr>
            <td class="tdoffice"></td><td class="tdoffice">{{o.zipCode}} {{o.city}}</td><td class="tdoffice">Mobiltel: {{o.phoneMobile}}</td>
          </tr>
          <tr>
            <td class="tdoffice"></td><td class="tdoffice">E-post: {{o.email}}</td><td class="tdoffice">Swish: {{o.swish}}</td>
          </tr>
        </div>
      </div>
        </table>



    </div>
</div>
</div>
    <div *ngIf="selectyears && !showLabelsAsHtml" class="col-md-8">

      <div class="col-lg-12">
        <form [formGroup]="selectyearform">

          <div class="row">

            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-10" style="min-width:500px;">
              <mat-expansion-panel [expanded]=true>
                <mat-expansion-panel-header [expandedHeight]="'48px'">
                  <mat-panel-title>
                    Välj år till lista - Medlemsavgifter
                  </mat-panel-title>
                  <mat-panel-description>

                  </mat-panel-description>
                </mat-expansion-panel-header>


                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="yearFrom">Från år</label>




                    <select class="form-control form-control-sm" id="yearFrom" formControlName="yearFrom" (change)="yearFromSelected($event)"
                      required>
                      <option></option>
                      <option *ngFor="let y of yearfromlist" [ngValue]="y">{{y}}</option>
                    </select>
                  </div>


                  <div class="form-group col-md-6" *ngIf="selectyearform.get('yearFrom').valid">
                    <label for="yearTo">Till år</label>
                    <select class="form-control form-control-sm" id="yearTo" formControlName="yearTo" required>
                      <option></option>
                      <option *ngFor="let y of yeartolist" [ngValue]="y">{{y}}</option>
                    </select>
                  </div>
                  <div class="col-md-12" style="margin-top:20px;margin-bottom:20px;">
                    <div *ngFor="let i of selectedinstitutions">
                      {{i.name}} ({{i.shortName}})
                    </div>
                  </div>
                </div>
                <div class="form-group">

                  <button class="btn border" [disabled]="!selectyearform.valid" (click)="generateFeeReport()">Skapa rapport</button>
                  <button class="btn border" (click)="clearYearForm()">Rensa</button>
                  <button class="btn border" (click)="back()">Gå tillbaka</button>
                </div>
              </mat-expansion-panel>
            </div>



          </div>
        </form>
      </div>

<br><br>
      <div *ngIf="showfeelist">

        <div class="row" style="border-bottom: 1px solid lightgrey;font-weight:bold;">
          <div class="col-md-3 inst">Institution</div>
          <div *ngFor="let y of institutionfeelist.years">
            <div class="cell">{{y}}</div>
          </div>
        </div>

        <div *ngFor="let i of institutionfeelist.institutions">
          <div class="row">
            <div class="col-md-3 inst">{{i.shortName}} {{i.name}}</div>
            <div *ngFor="let a of i.ammounts">
              <div class="cell" *ngIf="a > 0">{{a}}</div>
              <div class="cell" *ngIf="a < 1"></div>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</div>
<div *ngIf="showLabelsAsHtml">
  <div class="row">
    <div *ngFor="let inst of selectedinstitutions" class="col-xl-3">
      <div class="ml-2 mr-2 mb-4 p-1" style="border:1px solid lightgrey;">
        <div>{{inst.institutionType}}{{inst.institutionNumber}} {{inst.name}}</div>
        <div *ngIf="inst.careOf">{{inst.paymentAddress.careOf}}</div>
        <div *ngIf="!inst.paymentAddresscareOf">&nbsp;</div>
        <div>{{inst.paymentAddress.street}}</div>
        <div>{{inst.paymentAddress.zipCode}} {{inst.paymentAddress.city}}</div>
      </div>
    </div>
  </div>
</div>
<!--pre>{{selectyearform.value | json}}</pre-->
<!--pre>{{institutionform.value | json}}</pre-->
<!--div class="push"></div>



<ng-template #childTemplate>
  <div class="col-lg-1">
    <button class="btn btn-success" (click)="search()">Sök</button>
  </div>
</ng-template>

<app-footer [childTemplate]="childTemplate"></app-footer-->
<!--pre>{{selectedinstitutions | json}}</pre-->
